import { getVerdictStyle } from "@/utils/verdict";

export default function VerdictBadge({
  verdict,
  size = "md",
  showIcon = true,
}: {
  verdict: string;
  size?: "sm" | "md";
  showIcon?: boolean;
}) {
  const style = getVerdictStyle(verdict);
  const sizeClass = size === "sm" ? "text-[11px] px-2 py-0.5" : "text-xs px-2.5 py-1";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-control border font-medium whitespace-nowrap ${sizeClass} ${style.badge}`}
    >
      {showIcon && <i className="ri-checkbox-blank-circle-fill text-[7px]"></i>}
      {style.label}
    </span>
  );
}